import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth, installAuthInterceptor } from "./api";

const AuthContext = createContext({
  user: null,         // null = checking | object = authed | false = anonymous
  login: async () => {},
  logout: async () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Install interceptor once
  useEffect(() => {
    installAuthInterceptor(() => setUser(false));
  }, []);

  // Bootstrap: try to call /me with stored token
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!auth.getToken()) {
        if (!cancelled) setUser(false);
        return;
      }
      try {
        const me = await auth.me();
        if (!cancelled) setUser(me);
      } catch (_) {
        if (!cancelled) setUser(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const login = useCallback(async (email, password) => {
    const u = await auth.login(email, password);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    await auth.logout();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
